export const CSentryCurrentUrls = {
    SUB_BRANCH: '/MDK',
    LOCALHOST: 'localhost'
} as const;